// extracted by mini-css-extract-plugin
module.exports = {"title":"TradingViewHero_title__5MZA2"};